import { useMutation } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Box } from '@mui/material';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../../../components/popoverModal/PopoverModal';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import moment from 'moment';
import CustomButtonAdjuntar from '../../../../../components/customButton/CustomButtonAdjuntar';
import { AttachedFile } from '../../../../../components/attachedFile/AttachedFile';
import BORRAR_DOCUMENTOS_CAPA from '../../../../../data/graphQL/mutations/Capa/BorrarDocumentoCapa';

import toast from 'react-hot-toast';

const AdjuntosModal = ({
  idGestionCapa,
  idUsuarioLoggeado,
  nombreUsuarioLoggeado,
  onSaveAdjuntos,
  initialAdjuntos,
  submitLoading,
  disabled,
  queryAdjuntos
}) => {
  const attachColumns = [
    {
      field: 'action',
      flex: 1,
      headerName: '',
      align: 'center',
      renderCell: ({ row }) => {
        const rowIndex = row.id - 1;
        const showDeleteButton = row.idUsuario === idUsuarioLoggeado && !disabled;
        return (
          <PopoverModal key={`row-titulo-${row.titulo}-row-id${row.id}`}>
            <div className='popover-modal-content'>
              <AttachedFile
                file={{
                  archivo: row.archivo,
                  contentType: row.contentType,
                  extension: row.extension,
                  titulo: row.titulo
                }}
                type={!!row.idArchivo ? 'blob' : 'base64'}
                title='Ver'
                popoverMenuOption={true}
              />
              {showDeleteButton && <div
                aria-hidden='true'
                onClick={() => onDeleteRow(row, rowIndex)}
                className='item-option clickable-option'
              >
                <DeleteOutlinedIcon className='edit-icon' />
                <span className='toggle-action'>Borrar</span>
              </div>}
            </div>
          </PopoverModal>);

      }
    },
    { field: 'idArchivo', headerName: '#', flex: 2 },
    { field: 'titulo', headerName: 'Archivo', flex: 5 },
    { field: 'idUsuario', headerName: 'ID Usuario', flex: 5 },
    { field: 'usuario', headerName: 'Usuario', flex: 5 },
    { field: 'fechaAlta', headerName: 'Fecha de alta', flex: 5, type: 'date' }];


  const [openModal, setOpenModal] = useState(false);
  const [adjuntos, setAdjuntos] = useState(initialAdjuntos || []);

  useEffect(() => {
    setAdjuntos(initialAdjuntos || []);
  }, [initialAdjuntos]);

  const [borrarDocumento, { loading: borrarDocumentoLoading }] = useMutation(BORRAR_DOCUMENTOS_CAPA, {
  });

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onDeleteRow = (row, rowIndex) => {
    // Función auxiliar para filtrar adjuntos
    const filtrarAdjunto = (prev) =>
      prev.filter((adjunto, adjuntoIndex) => {
        const noCoincideId = row.idArchivo && row.idArchivo !== adjunto.idArchivo;
        const noCoincideIndex = rowIndex !== adjuntoIndex;
        return noCoincideId || noCoincideIndex;
      });

    // Función auxiliar para manejar la respuesta del borrado
    const handleBorradoExitoso = (res) => {
      if (res?.data?.borrarDocumentoCapa?.success) {
        setAdjuntos(filtrarAdjunto);
        queryAdjuntos({
          variables: {
            idGestionCapa: idGestionCapa
          }
        });
        toast.success('Adjunto eliminado.');
      }
    };

    if (!!row.idArchivo) {
      borrarDocumento({
        variables: {
          idArchivo: row.idArchivo
        }
      }).then(handleBorradoExitoso);
    } else {
      setAdjuntos(filtrarAdjunto);
    }
  };

  const handleAddFile = (file) => {
    const newAdjunto = {
      idGestionCapa,
      idUsuario: idUsuarioLoggeado,
      usuario: nombreUsuarioLoggeado,
      fechaAlta: moment().format('yyyy-MM-DD HH:mm:ss'),
      ...file
    };
    setAdjuntos((prev) => [...prev, newAdjunto]);
  };

  const onSubmit = useCallback(() => {
    onSaveAdjuntos(adjuntos).then(() => {
      if (!!idGestionCapa) {
        queryAdjuntos({
          variables: {
            idGestionCapa: idGestionCapa
          }
        });
      };

      handleCloseModal();
      setAdjuntos([]);
    });
  }, [adjuntos]);

  const attachConfigColumns = useMemo(() => generateColumnsDefaultConfiguration(attachColumns), []);

  return (
    <>
      <CustomButton
        label='Adjuntos'
        className='adjuntos'
        disabled={false}
        onClick={handleOpenModal}
        endIcon={<AttachFileIcon />}
        variant='standar' />

      <CustomDialog
        open={openModal}
        title={<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Archivos adjuntos
          {!disabled && <CustomButtonAdjuntar
            customButtonProps={{
              fullWidth: true,
              variant: 'outlined',
              component: 'label'
            }}
            onAddFile={handleAddFile} />
          }
        </Box>}
        acceptText='Agregar'
        onAccept={onSubmit}
        acceptDisabled={disabled}
        acceptLoading={submitLoading}
        cancelText='Cerrar'
        onCancel={handleCloseModal}
        fullWidth
        maxWidth='md'>

        <DataGridGenerico
          columns={attachConfigColumns}
          rows={adjuntos}
          totalCount={adjuntos.length}
          toolbar={false}
          hideFooterPagination={false} />

      </CustomDialog>
    </>);

};

export default AdjuntosModal;